<template lang="pug">
  div
    label(
      for="phone"
      v-if="label !== ''"
    )
      | {{ label }}
    masked-input.form__input(
      type="text"
      name="tel"
      id="tel"
      autocomplete="tel"
      class="form-control"
      v-model="value"
      :mask="['8', ' ', '(', /[0-9]/, /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/]"
      :guide="true"
      @input="onChange"
      :placeholder="placeholder"
    )
</template>

<script>
import MaskedInput from 'vue-text-mask';

export default {
  props: {
    phone: {
      required: true,
      type: String
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    placeholder: {
      required: false,
      type: String,
      default: 'Телефон'
    }
  },

  data() {
    return {
      value: ''
    };
  },

  mounted() {
    this.value = this.phone;
  },

  methods: {
    onChange() {
      // this.$emit('input', this.value);
      this.$emit('phoneInput', this.value);
    }
  },

  components: {
    MaskedInput
  }
};
</script>
